// extracted by mini-css-extract-plugin
export default {"inputGroup":"InputGroup_inputGroup__Ixjoq","input":"InputGroup_input__sF3eg","label":"InputGroup_label__hw4K5"};